import React, { useEffect } from 'react';
import { Navigate, NavigateProps } from 'react-router-dom';

import { useNavigate } from '@hooks/useNavigate';
import { ROUTES } from '@routes/routes.constants';
import { QUERY_STRINGS } from '@routes/routes.types';
import { authStore } from '@stores/authStore';
import { isLocalEnv } from '@utils/featureFlags';
import { urlSearchParams } from '@utils/navigation';

/** Utility wrapper on `react-router-dom` Navigate component that uses explicit props
 * or a URL search param for redirecting to a page. Used as a redirect and token refresh
 * for sato.fi when its login expires */
// TODO: move to components folder
export const Redirect = ({ to, ...props }: Partial<NavigateProps> = {}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUrl = urlSearchParams.getRedirect() ?? ROUTES.MY_HOME;

    if (isLocalEnv) {
      console.info('Redirecting to page', to ?? redirectUrl);
    }

    if (props) return;

    if (urlSearchParams.get(QUERY_STRINGS.REFRESH) === 'true') {
      authStore.refresh({ throwErrors: false });
    }

    navigate(redirectUrl, { replace: true });
  }, []);

  if (to) return <Navigate {...props} to={to} />;

  return null;
};
